// extracted by mini-css-extract-plugin
export default {"mainContainer":"UserPanelBox_mainContainer__z+4jn","noWifiContainer":"UserPanelBox_noWifiContainer__-4YG4"};